import { defineStore } from 'pinia';
import { pp, pp_user, notify, dateNow, hasRole, downloadFile } from '@helpers';
import { colisStore } from "@stores";
import DialogComponentForUpdateStatus from '@page/CarrierDoc/partials/DialogComponentForUpdateStatus.vue';

export const useCarrierDocStore = defineStore('carrierdoc', {
    state: () => ({
        loading: false,
        filter: '',
        filter_min_length: 2,
        table_fullscreen: false,
        columns: [
            { name: 'expand', align: 'center', label: '', field: 'expand' },
            { name: 'created_at', align: 'center', label: 'Dates<br/>Cr�ations', field: 'created_at', sortable: true },
            { name: 'status', align: 'center', label: 'Status', field: 'status', sortable: true },
            { name: 'count_colis', align: 'center', label: 'Nombre<br/>Colis', field: 'count_colis' },
            { name: 'ref', align: 'center', label: 'R�f�rences', field: 'ref' },
            { name: 'client_id', align: 'center', label: 'Exp�diteurs', field: 'client_id', sortable: true },
            { name: 'recipient_id', align: 'center', label: 'Destinataires', field: 'recipient_id', sortable: true },
            { name: 'actions', align: 'center', label: '', field: 'actions' },
        ],
        pagination: { rowsPerPage: 20, rowsNumber: 20, page: 1, sortBy: 'status', descending: false },
        form: {},
        openModalAddColis: {},
        recapMonthlyResult: [],
        recapMonthlyOpenModal: false,
    }),
    getters: {
        isValidable() {
            return (course) => Boolean(course?.client_id && course?.recipient_id);
        },
	carrierIsDisabledEdit(){

            return (course) => {
                if (course?.skey === "unavailable")
                {
                    return false;
                }
                return Boolean((Number(course?.status) >= 1 && course?.validated_at) || course?.deleted_at)
            }
        },       
	isDisabledHandleStatus() {
            return (course) => Boolean(Number(course?.status) == 2 || course?.deleted_at);
        },
        getValidationLabel() {
            return (course) => {
                if (!course?.validated_at && !course?.validate_by) return 'pas valid�';
                if (!course?.validated_at && course?.validate_by) return 'INVALID�E';
                if (course?.validated_at && course?.validate_by) return 'Valid�';
            };
        },
        getValidationColor() {
            return (course) => {
                if (!course?.validated_at && !course?.validate_by) return 'warning';
                if (!course?.validated_at && course?.validate_by) return 'red-8';
                if (course?.validated_at && course?.validate_by) return 'positive';
            };
        },
        getStatusLabel() {
            return (status) => pp().options_status_courses?.[status] ?? '?';
        },
        getStatusColor() {
            return (status) => {
                let color = 'warning';
                if (status === 0) color = 'grey';
                if (status === 1) color = 'teal-5';
                if (status === 2) color = 'positive';
                return color;
            };
        },
        getStatusIcon() {
            return (status) => {
                let icon = 'hourglass_top';
                if (status === 1) icon = 'local_shipping';
                if (status === 2) icon = 'done_all';
                if (status === 3) icon = 'person_off';
                if (status === 4) icon = 'highlight_off';
                return icon;
            };
        },
    },
    actions: {
        resetCourse(course_id) {
            proto.$inertia.get(route('carrier-doc-reset', course_id), { preserveScroll: true });
        },
        async requestList(d) {
            this.loading = true;
            if (_.size(this.filter) >= this.filter_min_length) {
                this.pagination.page = d.pagination.page = 1;
            }
            await proto.$inertia.get(route('carrier-doc.index'), {
                page: d.pagination.page,
                sortby: d.pagination.sortBy,
                order: d.pagination.descending,
                paginate: d.pagination.rowsPerPage,
                filter: this.filter,
            }, {
                onSuccess: (res) => {
                    this.pagination.rowsNumber = res.props.items.total;
                    this.pagination.page = res.props.items.current_page;
                    this.pagination.rowsPerPage = res.props.items.per_page;
                    this.pagination.descending = d.pagination.descending;
                    this.pagination.sortBy = d.pagination.sortBy;
                },
            });
            this.loading = false;
        },
        submit() {
            const router = this.form.id ? route('carrier-doc.update', this.form.id) : route('carrier-doc.store');
            const formDatas = this.form.data();
            proto.$inertia[this.form.id ? 'put' : 'post'](router, formDatas, {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
                onError: (res) => this.form.errors = res,
            });
        },
        updateExpand(item) {
            proto.$inertia.put(route('carrier-doc-update-expand', item.id), { expand: item.expand }, { preserveScroll: true });
        },
        updateStatus(course, status) {
            $q.Dialog.create({
                component: DialogComponentForUpdateStatus,
                componentProps: {
                    course: course,
                    status: status,
                },
            }).onOk(colis_selected => {
                proto.$inertia.post(route('carrier-doc-update-status', course.id), { status: status, colis_selected: colis_selected }, {
                    preserveScroll: true,
                });
            });
        },
        validation(item_id) {
            $q.dialog({
                title: 'Confirmation Validation...',
                message: '<p>Valider ou Non cette Course</p>',
                html: true,
                ok: { label: 'Confirmer', noCaps: true, color: 'positive', outline: true, square: true },
                cancel: true,
                persistent: true,
                options: {
                    type: 'radio',
                    model: 1,
                    items: [
                        { label: 'Oui', value: 1 },
                        { label: 'Non', value: 0 },
                    ],
                },
            }).onOk((validate) => {
                proto.$inertia.post(route('carrier-doc-validation', item_id), { validate: validate }, { preserveScroll: true });
            });
        },
        initForm(action, course) {
            if (!course) course = {};
            this.form = proto.$inertia.form({
                create_carrier_doc_in_same_time: false,
                id: course.id ?? null,
                client_id: course.client_id ?? (hasRole(pp().user.roles, 'client') ? pp().user.id : null),
                recipient_id: course.recipient_id ?? null,
                driver_id: course.driver_id ?? null,
                drivered_by: course.drivered_by ?? null,
                ref: course.ref ?? null,
                status: course.status ?? 0,
                expand: course.expand ?? 0,
                txt: course.txt ?? '',
                validate: false,
                colis: course.colis ?? [],
            });
        },
        addColis() {
            let new_colis = {
                course_id: this.form?.id,
                creator_id: this.form?.creator_id ?? pp_user().id,
                driver_id: this.form?.driver_id,
                recipient_id: this.form?.recipient_id,
                user_id: this.form?.client_id,
            };
            new_colis = colisStore().setColis(new_colis);
            this.form.colis?.push(new_colis);
            let k = _.size(this.form.colis) - 1;
            this.openModalAddColis[k] = true;
        },
        deleteColisInForm(k) {
            $q.dialog({
                title: 'Confirmation Suppression...',
                message: "Cette action n'enregistrera pas la Course.",
                html: true,
                ok: { label: 'Supprimer de la liste', noCaps: true, color: 'warning', outline: true, square: true },
                cancel: true,
                persistent: true,
            }).onOk(() => {
                this.form.colis.splice(k, 1);
                if (!this.form.colis?.length) {
                    this.form.create_carrier_doc_in_same_time = false;
                }
            });
        },
        groupedArchivage() {
            $q.dialog({
                title: "Archivage Group�...",
                message: "<p>Cette action archivera automatiquement toutes les courses termin�es depuis le nombre de jours que vous choisirez ci-dessous :</p>",
                html: true,
                ok: { label: 'Archiver', noCaps: true, color: 'positive', outline: true, square: true },
                cancel: true,
                persistent: true,
                options: {
                    type: 'radio',
                    model: 15,
                    items: [
                        { label: '10 jours', value: 10 },
                        { label: '15 jours', value: 15 },
                        { label: '20 jours', value: 20 },
                        { label: '25 jours', value: 25 },
                        { label: '30 jours', value: 30 },
                        { label: '45 jours', value: 45 },
                        { label: '60 jours', value: 60 },
                    ],
                },
            }).onOk((nb_days) => {
                proto.$inertia.post(route('carrier-doc-grouped-archivage'), { nb_days: nb_days }, { preserveScroll: true });
            });
        },
        recapMonthly() {
            let date_now = dateNow('YYYY-MM');
            let year = Number(dateNow('YYYY'));
            let month = Number(dateNow('MM'));
            let years = [{ label: year, value: year }];
            for (let y = year - 1; y >= year - 3; y--) {
                years.unshift({ label: y, value: y });
            }
            let months = [];
            $q.dialog({
                title: "Choisissez l'ann�e voulue",
                ok: { label: 'Continuer', noCaps: true, color: 'positive', outline: true, square: true },
                cancel: true,
                persistent: true,
                options: { type: 'radio', dense: true, model: year, items: years },
            }).onOk((year_selected) => {
                for (let m = 1; m <= 12; m++) {
                    let m_str = m < 10 ? '0' + m : m;
                    months.push({ label: m_str + '/' + year_selected, value: Number(m_str) });
                }
                $q.dialog({
                    title: "Choisissez le mois voulu en " + year_selected,
                    ok: { label: 'R�cap. Mensuelle', noCaps: true, color: 'positive', outline: true, square: true },
                    cancel: true,
                    persistent: true,
                    options: { type: 'radio', dense: true, model: month, items: months },
                }).onOk((month_selected) => {
                    let month_selected_str = month_selected < 10 ? '0' + month_selected : month_selected;
                    if (date_now < year_selected + '-' + month_selected) {
                        notify('warning', "Cette date n'est pas valide...", month_selected_str + '/' + year_selected);
                        return this.recapMonthly();
                    }
                    axios.post(route('carrier-doc-recap-monthly'), { year: year_selected, month: month_selected_str })
                        .then((res) => {
                            this.recapMonthlyResult = res.data ?? [];
                            this.recapMonthlyOpenModal = true;
                        })
                        .catch((err) => {
                            if (err.status == 403) {
                                return notify('warning', "Vous n'avez pas les droits n�cessaires...");
                            }
                        });
                });
            });
        },
        async exportXLS() {
            let courses_selected = this.recapMonthlyResult?.selected;
            let courses_ids = [];
            _.each(courses_selected, (v, c_id) => {
                if (v) courses_ids.push(c_id);
            });
            if (courses_ids.length) {
                $q.loading.show({ message: 'Fichier en cours de cr�ation...' });
                await axios.post(route('carrier-doc-export-xls'), {
                    courses_ids: courses_ids,
                    period: this.recapMonthlyResult?.period
                }, { responseType: 'blob' })
                    .then((res) => {
                        if (!res?.data) {
                            return notify('warning', "Ooops... L'exportation n'as pas aboutie.", "Quelque chose n'as pas d� fonctionner comme pr�vu...", 6000);
                        }
                        downloadFile(res);
                    })
                    .catch((error) => {
                        notify('warning', "L'exportation n'as pas aboutie...");
                    });
                $q.loading.hide();
            } else {
                notify('warning', "Aucune course s�lectionn�e...");
            }
        },
    },
});
